<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="9">
        <b-form-radio-group
          class="mr-3"
          id="radiosBtn"
          buttons
          button-variant="outline-primary"
          v-model="filterStatus"
          name="radiosBtn"
          @change.native="preprocessFilter"
        >
          <b-form-radio class="mx-0 longStandardizedRadioWidth" value="pending">Pending</b-form-radio>
          <b-form-radio class="mx-0 longStandardizedRadioWidth" value="inprocess">In Process</b-form-radio>
          <b-form-radio class="mx-0 longStandardizedRadioWidth" value="completed">Completed</b-form-radio>
          <b-form-radio class="mx-0 longStandardizedRadioWidth" value="all">Show All</b-form-radio>
        </b-form-radio-group>
      </b-col>
      <b-col lg="3">
        <div class="form-group form-actions float-right pb-2">
          <b-button class="mr-2 btn" variant="success" type="submit" size="md" @click="newCampaign">
            <i class="icon-layers"></i>
            New Print Order
          </b-button>
        </div>
        <div>
          <StyledDialog @filterList="filterList" :CurrentObject="mySelected" EntityType="Campaign">
            <div slot="header">
              <h2>PO#: {{mySelected.PONumber}}</h2>
            </div>
            <div slot="details">
              <div>{{mySelected.Dealership.CommonName}}</div>
              <div>{{mySelected.Description}}</div>
            </div>
            <span slot="entityType">Campaign</span>
          </StyledDialog>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="9">
        <!-- <b-form-input
          size="sm"
          class="mr-sm-2"
          type="text"
          placeholder="Search"
          @keyup="filterList"
          v-model="searchString"
        />-->
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i class="fa fa-times appendIcon clickIcon" @click="resetSearch"></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredCampaigns"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-show="data.item.Status === 'Created'"
              v-b-tooltip
              title="Delete"
              class="fa fa-trash"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";
import moment from "moment";

export default {
  name: "CampaignList",
  data: () => {
    return {
      fields: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;"
        },
        { key: "PONumber", label: "PO Number", sortable: true },
        { key: "DateOrdered", label: "Order Date", sortable: true },
        { key: "Dealership.CommonName", label: "Dealership", sortable: true },
        { key: "BelongsTo.FullName", label: "Ordered By", sortable: true },
        { key: "RequestedInHomeDate", label: "In Home Date", sortable: true },
        { key: "Status", label: "Status", sortable: true }
      ],
      mySelected: { Dealership: {} },
      currentPage: 1,
      perPage: 25,
      filteredCampaigns: [],
      filterStatus: "pending",
      searchString: ""
    };
  },
  components: {
    cTable,
    //DeleteDialog,
    StyledDialog
  },
  created() {
    this.$store.dispatch("campaign/fetchCampaigns").then(this.filterList());
    //this.filteredCampaigns = this.$store.state.campaign.campaigns;
    //this.filterList();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.campaign.campaigns.length;
      //return 4;
    },
    totalRowsFiltered: function() {
      return this.filteredCampaigns.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["campaign", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  updated() {
    this.incrementCount;
  },
  watch: {
    totalRows(newValue, oldValue) {
      //console.log(`Updating from ${oldValue} to ${newValue}`);
      this.filterList();
    }
  },
  methods: {
    filterList: function() {
      switch (this.filterStatus) {
        case "pending":
          this.filteredCampaigns = this.$store.state.campaign.campaigns.filter(
            campaign =>
              campaign.StatusCode === "Created" ||
              campaign.StatusCode === "Submitted" ||
              campaign.StatusCode === "Live Proofs Available"
          );
          break;
        case "inprocess":
          this.filteredCampaigns = this.$store.state.campaign.campaigns.filter(
            campaign =>
              campaign.StatusCode === "Approved" ||
              campaign.StatusCode === "Printed"
          );
          break;
        case "completed":
          this.filteredCampaigns = this.$store.state.campaign.campaigns.filter(
            campaign =>
              campaign.StatusCode === "Mail Sent" ||
              campaign.StatusCode === "Closed"
          );
          break;
        case "all":
          this.filteredCampaigns = this.$store.state.campaign.campaigns;
          break;
      }
      this.filterList2();
    },
    filterList2: function() {
      this.filteredCampaigns = this.filteredCampaigns.filter(
        campaign =>
          campaign.PONumber.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          campaign.Dealership.CommonName.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          campaign.BelongsTo.FullName.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          campaign.StatusCode.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );
    },
    preprocessFilter: function(event) {
      this.filterList();
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    },
    incrementCount() {
      this.$store.commit("INCREMENT_COUNT");
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    myRowClickHandler(record, index) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      //this.mySelected = record;

      // this.$store.dispatch("campaign/loadCampaignEdit", record.CampaignID);
      // this.$router.push({ path: "campaigns/edit" });

      this.$store
        .dispatch("campaign/loadCampaignEdit", record.CampaignID)
        .then(() => {
          this.$router.push({ name: "Campaign" });
        });
    },
    newCampaign() {
      this.$store
        .dispatch("campaign/New", this.createFreshCampaignObject())
        .then(() => {
          this.$router.push({ path: "campaigns/edit" });
          //,
          //params: { id: this.event.id }
        })
        .catch(() => {
          console.log("There was a problem");
          //.dispatch('notification/add', this.event)
        });
    },
    deleteUser() {
      //this.$store.dispatch("n_user/createUser", this.createFreshUserObject());
    },
    createFreshCampaignObject() {
      return {
        CampaignID: -1,
        OrderedBy: this.$store.state.n_user.n_current_user.UserProfileID,
        Dealership: {},
        Approver: {},
        StatusCode: "Created",
        PostageClass: "First Class",
        RequestedMailDate: this.GetEarliestMailDate() - 3,
        RequestedInHomeDate: this.GetEarliestMailDate(),
        BelongsTo: {
          FullName: this.$store.state.n_user.n_current_user.FullName
        }
      };
    },
    GetEarliestMailDate() {
      switch (moment().day()) {
        // If it is Monday (1),Saturday(6), or Sunday (0), Get the previous Friday (5)
        // and ensure we are on the previous week
        case 0:
          return moment().add(5, "days");
        case 1:
          return moment().add(4, "days");
        case 2:
          return moment().add(10, "days");
        case 3:
          return moment().add(9, "days");
        case 4:
          return moment().add(8, "days");
        case 5:
          return moment().add(7, "days");
        case 6:
          return moment().add(6, "days");
        default:
          return moment().add(3, "days");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>